import React, { useState, useEffect } from "react";
import "./ProudHistory.css";
import doctor from "../Assets/Images/doctor.jpg";
import nurse from "../Assets/Images/image-asset.jpeg";
import patient from "../Assets/Images/iStock-1440720887-900x900.webp";

const images = [nurse, doctor, patient]; // Store images in an array

const ProudHistory = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 2000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <div className="container-fluid">
      <div className="row justify-content-center history my-5">
        <div className="col-md-4 position-relative imagearea">
          <div className="imagearea-box position-absolute"></div>
          <div className="imagearea-image position-absolute">
            <img id="img" src={images[currentImageIndex]} alt="History" />
          </div>
        </div>
        <div className="col-md-4 textarea position-relative p-5">
          <h4 className="my-4">ABOUT US</h4>
          <h2 className="my-4">
            <strong>
              Committed to Providing Compassionate High-Quality Care
            </strong>
          </h2>
          <p className="my-4">
            We are dedicated to delivering exceptional, high-quality care that
            enriches the lives of our residents. We understand that choosing a
            nursing home is a significant decision, and we strive to create a
            warm, welcoming, and nurturing environment where every individual
            feels valued, respected, and truly at home.
          </p>
          <p className="my-4">
            Our team of highly skilled professionals, including experienced
            nurses and compassionate caregivers, works collaboratively to
            provide personalized care tailored to the unique needs of each
            resident. We take pride in fostering a supportive community where
            health, comfort, and well-being are our top priorities.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProudHistory;
